module.exports = "https://web-assets.ifttt.com/packs/media/docs/qapital_connect_example-2add0a7f.png";